import * as R from 'ramda';

export const capitalize = (val) => R.toUpper(R.head(val)) + R.tail(val);
